import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

export const myHubKeys = {
  getMyHub: ({
    companyId,
    articleType,
    username,
  }: {
    companyId: string;
    articleType: ArticleSourceType;
    username: string;
  }) => ['my-hub', companyId, username, articleType],
  getUnassignedSuggestions: ({ companyId }: { companyId: string }) => [
    'unassigned-suggestions',
    companyId,
  ],
};
